export default (node) => {
  const colors = JSON.parse(node.dataset.colors);
  const allColors = node.querySelectorAll('[data-color-handle]');

  const getColorSlug = () => {
    const urlSplit = window.location.href.split('/');
    const slug = urlSplit[urlSplit.length - 1];
    const colorSlug = slug.split('?')[0];
    return colorSlug;
  };

  const init = () => {
    const colorSlug = getColorSlug();
    if (colors) {
      const colorFound = colors.find((color) => color.handle === colorSlug);
      if (colorFound) {
        allColors.forEach((color) => {
          color.classList.remove('active');
          if (color.dataset.colorHandle === colorFound.handle) {
            color.classList.add('active');
          }
        });
      }
    }
  };

  init();
};
